document.addEventListener("DOMContentLoaded", () => {
  const stickyCart = document.querySelector(".sp-sticky-product-form");
  const targetElement = document.querySelector(
    ".sp-product__add-to-cart__wrapper.product-form"
  );

  if (!stickyCart || !targetElement) {
    return;
  }

  const toggleStickyCart = (isVisible) => {
    stickyCart.style.display = isVisible ? "none" : "flex";
  };

  let observer;

  const handleResize = () => {
    const isSmallScreen = window.matchMedia("(max-width: 576px)").matches;

    if (isSmallScreen) {
      if (!observer) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              toggleStickyCart(entry.isIntersecting);
            });
          },
          {
            root: null,
            threshold: 0,
          }
        );

        observer.observe(targetElement);
      }

      const rect = targetElement.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
      toggleStickyCart(isVisible);
    } else {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      stickyCart.style.display = "none";
      t;
    }
  };

  handleResize();

  window.addEventListener("resize", handleResize);
});
